import React from 'react';
import PropTypes from 'prop-types';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { CardContainer, CardMediaStyled } from './Card.styled';

export default function MediaCard(props) {
  const { img, title, description, publishTime, id, onClick } = props;

  function handleClick() {
    onClick({
      img,
      title,
      description,
      publishTime,
      id,
    });
  }

  return (
    <CardContainer onClick={handleClick}>
      <CardActionArea>
        <CardMediaStyled image={img} title={title} />
        <CardContent>
          <Typography gutterBottom variant="h6" component="h2">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </CardContainer>
  );
}

MediaCard.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  publishTime: PropTypes.string.isRequired,
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
